import { Navigate, useParams } from "react-router-dom";
import { appRoutes } from "@/app/router/appRoutes";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { useAppStore } from "@/store";

export const ClassicChatHistoryRedirect = () => {
  const { pageStore } = useAppStore();
  const { sessionId } = useParams<{ sessionId?: string }>();

  useEffectOnMount(() => {
    pageStore.classicChatHistory.openHistoryModal(sessionId);
  });

  return <Navigate to={appRoutes.notesList({}).path} replace />;
};
